export { default as SalesPolicy } from './sales_policy/screen/SalesPolicy';
export { default as UpdateSalesPolicy } from './sales_policy/screen/UpdateSalesPolicy';

export { default as PaymentProgress } from './payment_progress/screen/PaymentProgress';
export { default as UpdatePaymentProgress } from './payment_progress/screen/UpdatePaymentProgress';

export { default as SaleCampaign } from './sales_campaign/screen/SaleCampaign';
export { default as UpdateSaleCampaign } from './sales_campaign/screen/UpdateSaleCampaign';

export { default as TransactionCustomer } from './transaction_customer/screen/TransactionCustomer';